<div class="row">
  <div class="col col-1">
  </div>
  <div class="col-2 bold">
    <p>Huidige periode</p>
  </div>
  <div class="col-3 bold">
    <p>Vorige periode</p>
  </div>
</div>
<ng-container *ngIf="this.showCustomControls">
  <form [formGroup]="revenuesFromSaleOfGoodsFg">
    <div class="row">
      <div class="col col-1">
        <p style="padding: 6px">Opbrengsten uit de verkoop van goederen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="plus"
                             class="custom-input-150"
                             (click)="this.showDialog(1)">Specificeer
        </snelstart-ui-button>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-4">
        <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  </form>
  <form [formGroup]="revenuesFromProvidingServicesFg">
    <div class="row">
      <div class="col col-1">
        <p style="padding: 6px">Opbrengsten uit het verlenen van diensten</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="plus"
                             class="custom-input-150"
                             (click)="this.showDialog(2)">Specificeer
        </snelstart-ui-button>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-4">
        <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  </form>
  <form [formGroup]="revenuesFromInterestFg">
    <div class="row">
      <div class="col col-1">
        <p style="padding: 6px">Opbrengsten uit rente</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="plus"
                             class="custom-input-150"
                             (click)="this.showDialog(3)">Specificeer
        </snelstart-ui-button>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-4">
        <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  </form>
  <form [formGroup]="revenuesFromRoyaltiesFg">
    <div class="row">
      <div class="col col-1">
        <p style="padding: 6px">Opbrengsten uit royalties</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="plus"
                             class="custom-input-150"
                             (click)="this.showDialog(4)">Specificeer
        </snelstart-ui-button>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-4">
        <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  </form>
  <form [formGroup]="revenuesFromDividendsFg">
    <div class="row">
      <div class="col col-1">
        <p style="padding: 6px">Opbrengsten uit dividenden</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="plus"
                             class="custom-input-150"
                             (click)="this.showDialog(5)">Specificeer
        </snelstart-ui-button>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-4">
        <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  </form>
  <form [formGroup]="revenuesFromLicensesFg">
    <div class="row">
      <div class="col col-1">
        <p style="padding: 6px">Opbrengsten uit licenties</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="plus"
                             class="custom-input-150"
                             (click)="this.showDialog(6)">Specificeer
        </snelstart-ui-button>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-4">
        <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  </form>
  <form [formGroup]="revenuesOtherFg">
    <div class="row">
      <div class="col col-1">
        <p style="padding: 6px">Opbrengsten uit overige bronnen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="plus"
                             class="custom-input-150"
                             (click)="this.showDialog(7)">Specificeer
        </snelstart-ui-button>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-4">
        <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  </form>
  <form [formGroup]="netRevenueFg">
    <div class="row">
      <div class="col col-1">
        <p style="padding: 6px"><b>Totaal van netto omzet</b></p>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-4">
        <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                          class="custom-input-150 custom-readonly"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          [disabledControl]="true"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  </form>
</ng-container>

<div *ngIf="this.index === 1">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.revenuesFromSaleOfGoodsFg"
                                                       [title]="'opbrengsten uit de verkoop van goederen'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 2">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.revenuesFromProvidingServicesFg"
                                                       [title]="'opbrengsten uit het verlenen van diensten'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 3">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.revenuesFromInterestFg"
                                                       [title]="'opbrengsten uit rente'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 4">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.revenuesFromRoyaltiesFg"
                                                       [title]="'opbrengsten uit royalties'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 5">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.revenuesFromDividendsFg"
                                                       [title]="'opbrengsten uit dividenden'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 6">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.revenuesFromLicensesFg"
                                                       [title]="'opbrengsten uit licenties'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 7">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.revenuesOtherFg"
                                                       [title]="'opbrengsten uit overige bronnen'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>

